<template>
  <div class="form-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LayoutForm'
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';

.form-layout {
  height: 100%;
  min-height: 100vh;

  background-color: var(--neutral-color-5);
}
</style>
